import { render, staticRenderFns } from "./m-tag-lake.vue?vue&type=template&id=1c01ac70&scoped=true&"
import script from "./m-tag-lake.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-tag-lake.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-tag-lake.vue?vue&type=style&index=0&id=1c01ac70&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c01ac70",
  null
  
)

export default component.exports